// import { motion, useScroll, useTransform } from "motion/react";
import { cn } from "../../utilities";

import styles from "./howItWorks.module.scss";
import headerStyles from "../header/header.module.scss";
import { useEffect, useRef, useState } from "react";

const VIDEO_STATE = {
  PLAYING: "PLAYING",
  PAUSED: "PAUSED",
  ENDED: "ENDED",
};

export function HowItWorksVideo() {
  const video = useRef(null);
  const [videoState, setVideoState] = useState(VIDEO_STATE.PLAYING);
  const [muteVideo, setMuteVideo] = useState(true);

  // useEffect(() => {
  //   const attachVideoEndListener = () => {
  //     if (!video.current) return;
  //     video.current.addEventListener("ended", () => {
  //       setVideoState(VIDEO_STATE.ENDED);
  //     });
  //   };

  //   setTimeout(() => {
  //     playInfoVideo(true);
  //     attachVideoEndListener();
  //   }, 1000);
  // }, []);

  useEffect(() => {
    if (!video.current) return;
    video.current.play();
  }, [video]);

  // const playInfoVideo = (val) => {
  //   if (!video.current) return;
  //   const _video = video.current;

  //   if (typeof val === "boolean") {
  //     if (val) {
  //       if (videoState === VIDEO_STATE.ENDED) {
  //         _video.currentTime = 0;
  //       }
  //       _video.play();
  //       setVideoState(VIDEO_STATE.PLAYING);
  //     } else {
  //       _video.pause();
  //       setVideoState(VIDEO_STATE.PAUSED);
  //     }
  //     return;
  //   }

  //   if (videoState === VIDEO_STATE.PLAYING) {
  //     _video.pause();
  //     setVideoState(VIDEO_STATE.PAUSED);
  //     return;
  //   }
  //   if (videoState === VIDEO_STATE.ENDED) {
  //     _video.currentTime = 0;
  //   }
  //   _video.play();
  //   setVideoState(VIDEO_STATE.PLAYING);
  // };

  const toggleVideoSound = () => {
    if (!video.current) return;
    const muted = video.current.muted;
    video.current.muted = !muted;
    setMuteVideo(!muted);
  };

  return (
    <div className={styles.videoContainer}>
      <video
        playsInline
        autoplay
        loop
        muted
        preload="none"
        id="final8-explainer"
        className={cn(styles.video)}
        ref={video}
      >
        <source
          src="video/Exp-Portrait.mp4"
          type="video/mp4"
          media="(orientation: portrait)"
        />
        <source
          src="video/Exp-Landscape.mp4"
          type="video/mp4"
          media="(orientation: landscape)"
        />
      </video>
      <div className={styles.videoControls}>
        <button onClick={toggleVideoSound}>
          {muteVideo ? (
            <img
              alt="Volume off"
              height="21px"
              width="21px"
              src="icons/Volume_Off.svg"
            />
          ) : (
            <img
              alt="Volume on"
              height="21px"
              width="21px"
              src="icons/Volume_On.svg"
            />
          )}
        </button>
      </div>
      {/* <div
        className={cn(headerStyles.videoControls, styles.videoControlOverrides)}
      >
        <button onClick={toggleVideoSound}>
          {muteVideo ? (
            <img
              alt="Volume off"
              height="21px"
              width="21px"
              src="icons/Volume_Off.svg"
            />
          ) : (
            <img
              alt="Volume on"
              height="21px"
              width="21px"
              src="icons/Volume_On.svg"
            />
          )}
        </button>
        <button onClick={playInfoVideo}>
          {videoState === VIDEO_STATE.PLAYING ? (
            <img alt="Pause" height="21px" width="21px" src="icons/Pause.svg" />
          ) : (
            <img alt="Play" height="21px" width="21px" src="icons/Play.svg" />
          )}
        </button>
      </div> */}
    </div>
  );
}
